// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"201":"component---src-gatsby-entities-page-tsx","336":"component---node-modules-shapeable-gatsby-theme-shapeable-web-src-components-404-tsx"}[chunkId] + "-" + {"201":"e9189e46aa2ddae006d5","336":"4669ad1b409e70bf52c3"}[chunkId] + ".js";
};